"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShareOptions = exports.config = exports.addShare = exports.addProductShare = void 0;
exports.getSign = getSign;
exports.wechat = exports.ready = exports.loadWxJs = void 0;

var _fetch = _interopRequireDefault(require("./fetch"));

var load = _interopRequireWildcard(require("./load"));

var _bridge = _interopRequireDefault(require("./bridge"));

var _tools = require("./tools");

var _excluded = ["channel"],
    _excluded2 = ["channel", "link"],
    _excluded3 = ["pageId", "pageCode", "shareId", "title", "desc", "imgUrl"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var root = {};

if (typeof window !== 'undefined') {
  root = window;
}
/**
 * 加载微信js
 * @returns
 */


var loadWxJs = function () {
  var jsLoading = false;
  var callbacks = [];
  return function () {
    return new Promise(function (resolve) {
      // 如果已经加载 则进行等待
      if (root.wx) {
        resolve(root.wx);
        return;
      } // 当前已经在加载wxjs文件


      if (jsLoading) {
        callbacks.push(resolve);
      } else {
        jsLoading = true;
        load.js('//res.wx.qq.com/open/js/jweixin-1.6.0.js', function () {
          jsLoading = false;
          resolve(root.wx);
          callbacks.map(function (func) {
            return func(root.wx);
          });
        });
      }
    });
  };
}();
/**
 * 获取签证信息
 * @param channel
 */


exports.loadWxJs = loadWxJs;

function getSign(channel) {
  var url = encodeURIComponent(root.location.href);

  if (channel) {
    url = "".concat(url, "&gzh=").concat(channel);
  }

  return _fetch.default.fetch({
    path: "/facilities/open/v1/wechat/jsSign?url=".concat(url),
    server: 'api',
    method: 'GET'
  }).then(function (_ref) {
    var result = _ref.result;
    result = result || {};
    return {
      appId: result.appId,
      nonceStr: result.nonceStr,
      timestamp: result.timestamp,
      signature: result.signature
    };
  });
}
/**
 * 配置
 * @param  {object} options    配置信息
 * @config {bool}   debug      调试
 * @config {string} channel    来源
 * @config {array}  jsApiList  API功能配置
 */


var config = function config(options) {
  options = _objectSpread({
    debug: false,
    channel: '',
    jsApiList: []
  }, options);

  var _options = options,
      channel = _options.channel,
      rest = _objectWithoutProperties(_options, _excluded); // 后去签字


  return Promise.all([loadWxJs(), getSign(channel)]).then(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        wx = _ref3[0],
        wxConfig = _ref3[1];

    // 设置配置信息
    wx.config(_objectSpread(_objectSpread({}, wxConfig), rest));
    return wx;
  }).catch(function (error) {
    console.error('error', error);
  });
};
/**
 * 微信SDK，加载完成（循环判断）
 * @param {function} func 回调
 * @DELETE 废弃使用
 */


exports.config = config;

var ready = function ready(cb) {
  return new Promise(function (resolve) {
    // 配置完成后
    config().then(function (wx) {
      // 配置未完成不会进行ready接口
      wx.ready(function () {
        resolve(wx);
        cb && cb(wx);
      });
      wx.error(function (error) {
        // 监听失败信息
        console.error('error', error);
      });
    });
  });
};
/**
 * 微信分享
 * @param  {object}   options 分享文案
 * @config {string}   title   标题
 * @config {string}   desc    详情
 * @config {string}   imgUrl  图片
 * @config {string}   link    链接
 * @config {string}   channel 来源
 * @param  {bool}     debug   调试
 */


exports.ready = ready;

var wechat = function wechat(options) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  options.link = options.link || root.location.href;

  var _options$channel = options.channel,
      channel = _options$channel === void 0 ? '' : _options$channel,
      link = options.link,
      others = _objectWithoutProperties(options, _excluded2);

  var wxOptions = _objectSpread({
    title: document.title,
    desc: '',
    imgUrl: '',
    link: link
  }, others); // 配置


  config({
    debug: debug,
    channel: channel,
    jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone']
  }).then(function (wx) {
    // 微信配置成功后的回调
    wx.ready(function () {
      // 如果当前微信版本为1.6.0 版本 则更新为新的设置分享的方法
      // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#63
      // @TODO delete 待后续删除 2021.11.25
      if (wx.updateAppMessageShareData) {
        wx.updateAppMessageShareData(wxOptions);
        wx.updateTimelineShareData(wxOptions);
      } else {
        wx.onMenuShareTimeline(wxOptions);
        wx.onMenuShareAppMessage(wxOptions);
        wx.onMenuShareQQ(wxOptions);
        wx.onMenuShareQZone(wxOptions);
      }
    });
  });
};
/**
 * 添加APP分享按钮和微信分享
 * @param  {object}   options 分享文案
 * @config {string}   title   标题
 * @config {string}   desc    详情
 * @config {string}   imgUrl  图片
 * @config {string}   link    链接
 * @param  {object}   btnOptions APP按钮配置
 * @config {string}   title   文字
 * @param  {func}     callback 点击分享回调
 */


exports.wechat = wechat;

var addShare = function addShare(options, btnOptions, callback) {
  options = _objectSpread({
    title: document.title,
    desc: '',
    imgUrl: '',
    link: window.location.href
  }, options);

  if (_tools.isInWechat) {
    wechat(options, false);
  } else {
    _bridge.default.ready(function () {
      if (btnOptions && !btnOptions.imageUrl && !btnOptions.title) {
        btnOptions.title = '分享';
      }

      _bridge.default.setRightShare(options, btnOptions);

      callback && callback();
    });
  }
};
/**
 * 获取分享参数
 * @param  {object}   options 分享文案
 * @config {string}   title   标题
 * @config {string}   desc    详情
 * @config {string}   imgUrl  图片
 * @config {string}   link    链接
 * @config {string}   pageId  产品ID
 * @param  {func}     callback 回调
 */


exports.addShare = addShare;

var getShareOptions = function getShareOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  options = _objectSpread({
    title: document.title,
    desc: '',
    imgUrl: '',
    link: window.location.href
  }, options);

  var _options2 = options,
      pageId = _options2.pageId,
      pageCode = _options2.pageCode,
      shareId = _options2.shareId,
      title = _options2.title,
      desc = _options2.desc,
      imgUrl = _options2.imgUrl,
      restParams = _objectWithoutProperties(_options2, _excluded3); // 页面code


  var urlPageCode = pageCode || (0, _tools.getParameterByName)('pageCode') || 'cp'; // 页面ID

  var urlPageId = pageId || (0, _tools.getParameterByName)('pageId'); // 分享ID

  var urlShareId = shareId || (0, _tools.getParameterByName)('shareId'); // 产品ID

  var urlProductId = (0, _tools.getParameterByName)('productId') || (0, _tools.getParameterByName)('product_id') || (0, _tools.getParameterByName)('id') || (0, _tools.getParameterByName)('wareId');
  var aSign = restParams.aSign || (0, _tools.getParameterByName)('aSign'); // 清除对应的数据

  delete options.pageId;
  delete options.pageCode;
  options.link = (0, _tools.addParameterByName)('pageCode', urlPageCode);
  (0, _tools.getAppAccountId)().then(function (accountId) {
    var parmas = _objectSpread(_objectSpread({}, restParams), {}, {
      // 当前链接
      originalLink: window.location.href,
      // 页面ID
      pageId: urlPageId || urlProductId,
      // 分享标题
      pageTitle: title,
      // 分享图片
      pageIcon: options.imgUrl,
      pageCode: urlPageCode,
      shareId: urlShareId,
      accountId: accountId
    });

    if (aSign) {
      parmas.aSign = aSign;
    } // productId 用于产品推荐文章


    if (parmas.pageId) {
      options.productId = parmas.pageId;
    } // 微信机制修改，不能设置两次。防止接口出错
    // callback && callback(options);


    _fetch.default.fetch({
      path: '/app/visitor/zyb/receptionlink/newShareLink.json',
      server: 'gw',
      method: 'POST',
      data: parmas,
      timeout: 5000
    }).then(function (_ref4) {
      var result = _ref4.result,
          content = _ref4.content;

      if (result === 'success' && content) {
        options.link = content.shareLink;
      }

      callback && callback(options);
    }).catch(function () {
      console.error('获取分享链接服务异常！');
      callback && callback(options);
    });
  });
};
/**
 * 添加产品顶部右边按钮
 * @param  {object}   options 分享文案
 * @config {string}   title   标题
 * @config {string}   desc    详情
 * @config {string}   imgUrl  图片
 * @config {string}   link    链接
 * @config {string}   pageId  产品ID
 * @param  {object}   btnOptions APP按钮配置
 * @config {string}   title   文字
 * @param  {func}     callback 点击分享回调
 */


exports.getShareOptions = getShareOptions;

var addProductShare = function addProductShare(options, btnOptions, callback) {
  getShareOptions(options, function (o) {
    addShare(o, btnOptions, callback);
  });
};

exports.addProductShare = addProductShare;